import type { FunctionComponent } from 'react'

import { FlowPage, H2 } from '@monthio/design-system'
import { useTranslation } from 'react-i18next'

import type {
	WhiteLabelSubdomainInfo,
	WhitelabelSubdomainTranslation,
} from '../../../api/budgetApiClient'

import Header from '../../../components/SmartcheckFlowHeader/Header'
import { getLocalizedLanguageCode } from '../../../utils/languageCodeMapper'
import { DocumentboardSVGComponent } from '../GenericLandingPageImageComponent'
import { ParingChoiceSelector } from '../ParingChoiceSelector'

const findTranslation = (
	translations: WhitelabelSubdomainTranslation[],
	part: 'translationHeader' | 'translationBody' | 'translationPairingChoice',
): string | null => {
	if (!translations) {
		return null
	}
	const currentLanguageCode = getLocalizedLanguageCode()

	const translation = translations.find(
		(t) => t.languageCode === currentLanguageCode && t[part]?.length,
	)
	if (translation) {
		return translation[part]
	}

	return null
}

export const ClientDomainLandingPageContent: FunctionComponent<{
	subdomainInfo: WhiteLabelSubdomainInfo
	consumerInputsStepIndex?: number
}> = ({ subdomainInfo, consumerInputsStepIndex }) => {
	const { t } = useTranslation()

	const customCopyHeader =
		findTranslation(
			subdomainInfo.whitelabelSubdomainTranslations,
			'translationHeader',
		) ?? t('generic-landing-page-title')

	const customCopyBody = findTranslation(
		subdomainInfo.whitelabelSubdomainTranslations,
		'translationBody',
	)
	const customCopyPairingChoice =
		findTranslation(
			subdomainInfo.whitelabelSubdomainTranslations,
			'translationPairingChoice',
		) ?? t('genericLandingPage-pairingChoice-explainer')

	return (
		<>
			<Header
				smartCheckConfiguration={
					subdomainInfo.logo ? ({ logo: subdomainInfo.logo } as any) : null
				}
				consumerInputsStepIndex={consumerInputsStepIndex}
			/>
			<FlowPage>
				<FlowPage.Content $spacing="l">
					<DocumentboardSVGComponent />
					<FlowPage.Header
						title={customCopyHeader || t('generic-landing-page-title')}
						description={
							customCopyBody ||
							t('generic-landing-page-description', {
								clientName: subdomainInfo.clientName,
							})
						}
					/>
					<H2>{customCopyPairingChoice}</H2>
					<ParingChoiceSelector />
				</FlowPage.Content>
			</FlowPage>
		</>
	)
}
